/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import reactUpdate from 'immutability-helper';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import filestates from 'FileStates';
import ManageSelectorsModalClass from 'notebook/plain-tables/selectors/ManageSelectorsModal';
// @ts-expect-error
import ProtocolViewComponent from 'notebook/protocols/ProtocolViewComponent';
// @ts-expect-error
import HistoryManager from 'notebook/store/HistoryManager';
import notifications from 'notifications';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import * as vo from 'settings/visibility-options/VisibilityOptions';
import * as ModalContainer from 'ui-library/ModalContainer';

interface EntryProtocolTabViewComponentProps {
  protocol: any;
  locked: boolean;
  updateProtocol: (newProtocol: any) => void;
  revertProtocol: (protocol: any, selectionData: any) => void;
  banner?: string;
  fileId: string;
  onSaving?: () => void;
  onRetrying?: () => void;
  onSaved?: () => void;
  onLoad: () => void;
  printHandler?: () => void;
  printOptions: Array<any>;
  spellCheck: boolean;
  printLayout: boolean;
  showPrintMargins: boolean;
  protocolID: string;
  displayOptions: any;
}
type State = any;

class EntryProtocolTabViewComponent extends React.Component<EntryProtocolTabViewComponentProps, State> {
  constructor(props: EntryProtocolTabViewComponentProps) {
    super(props);
    this.state = {
      historyManager: new HistoryManager(),
      showManageSelectorsModal: false,
      initialSelectorId: null,
      ...this.getMoreFormats(props),
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: EntryProtocolTabViewComponentProps): void {
    if (
      this.props.protocol.originalProtocolId !== nextProps.protocol.originalProtocolId ||
      this.props.locked !== nextProps.locked
    ) {
      this.setMoreFormats(nextProps);
    }
  }

  componentDidUpdate(prevProps: EntryProtocolTabViewComponentProps, prevState: State): void {
    const manageSelectorsModalProps = {
      initialSelectorId: this.state.initialSelectorId,
      locked: this.props.locked,
      parentType: 'Protocol',
      selectorsLink: {
        value: this.props.protocol.selectors,
        requestChange: this.updateSelectors,
        selectorUsageCounts: ManageSelectorsModalClass.countSelectors(this.props.protocol.steps),
      },
      onRequestClose: this.closeManageSelectorsModal,
    };
    this.toggleManageSelectorsModal(prevState, this.state, manageSelectorsModalProps);
  }

  toggleManageSelectorsModal = (prevState: any, curState: any, manageSelectorsModalProps: any): void => {
    if (curState.showManageSelectorsModal) {
      ModalContainer.open(
        ManageSelectorsModalClass,
        <ManageSelectorsModalClass {...manageSelectorsModalProps} />
      );
    } else if (prevState.showManageSelectorsModal && !curState.showManageSelectorsModal) {
      this.closeManageSelectorsModal();
    }
  };

  openManageSelectorsModal = (initialSelectorId: any): void => {
    this.setState({showManageSelectorsModal: true, initialSelectorId});
  };

  closeManageSelectorsModal = (): void => {
    this.setState({showManageSelectorsModal: false, initialSelectorId: null});
    ModalContainer.close(ManageSelectorsModalClass);
  };

  updateSelectors = (newSelectors: any): void => {
    const newProtocol = reactUpdate(this.props.protocol, {$merge: {selectors: newSelectors}});
    this.props.updateProtocol(newProtocol);
  };

  getMoreFormats = (
    props: EntryProtocolTabViewComponentProps
  ): {
    moreFormats: Array<{
      format: string;
      moreKey: string;
      onClick: (initialSelectorId: any) => void;
      tooltip: Array<string>;
    }>;
  } => ({
    moreFormats: [
      {
        format: 'selector',
        moreKey: 'default',
        tooltip: [props.locked ? 'Manage Selectors' : 'View Selectors'],
        onClick: this.openManageSelectorsModal,
      },
      {
        format: 'original-protocol',
        tooltip: ['Open Original Protocol'],
        moreKey: 'default',
        onClick() {
          if (props.protocol.originalProtocolId != null) {
            filestates.get().openFolderItem(props.protocol.originalProtocolId);
          } else {
            notifications.error('The original protocol was deleted.');
          }
        },
      },
    ],
  });

  setMoreFormats = (props: EntryProtocolTabViewComponentProps): void => {
    this.setState(this.getMoreFormats(props));
  };

  render(): JSX.Element {
    return (
      <div>
        <ProtocolViewComponent
          // eslint-disable-next-line no-restricted-syntax
          {..._.extend({}, this.props, {
            historyManager: this.state.historyManager,
            openManageSelectorsModal: this.openManageSelectorsModal,
            moreFormats: this.state.moreFormats,
          })}
        />
      </div>
    );
  }
}

/* eslint-disable @typescript-eslint/unbound-method */
class EntryProtocolTabView extends Backbone.View<any> {
  declare printOptions: any;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  static initClass() {
    this.prototype.className = 'buffer-tab';
    this.prototype.printOptions = ['protocol', 'entry'];
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  initialize() {
    // Bind methods to `this` so they can be threaded into React components
    this.revertProtocol = this.revertProtocol.bind(this);
    this.updateProtocol = this.updateProtocol.bind(this);
    this.onLoadProtocol = this.onLoadProtocol.bind(this);

    this.listenTo(this.model.file(), 'change', this.render);
    this.listenTo(this.model.get('displayOptions'), 'redraw', this.render);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  revertProtocol(protocol: any, selectionData: any) {
    this.model.revertProtocol(protocol, selectionData);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateProtocol(data: any) {
    this.model.updateProtocol({$merge: data});
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onLoadProtocol() {
    const scroller = this.$('.protocolEditor-pageContainer');
    scroller.scroll(() => this.model.set('scrollTop', scroller.scrollTop()));
    _.defer(() => this.$('.protocolEditor-pageContainer').scrollTop(this.model.get('scrollTop')));
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const protocol = this.model.protocol();
    // early exit if protocol is null, as the tab shouldn't re-render
    if (protocol == null) {
      return this;
    }
    const proxyFile = this.model.file();

    const printLayoutOption = this.model.get('displayOptions').getOption(vo.ELN_PRINT_LAYOUT.name);
    const component = (
      <EntryProtocolTabViewComponent
        banner={proxyFile.getBannerText()}
        fileId={this.model.file().id}
        protocol={protocol}
        locked={!proxyFile.allowEdits()}
        printHandler={this.model.printHandler}
        printOptions={this.model.printOptions()}
        protocolID={protocol.id}
        updateProtocol={this.updateProtocol}
        revertProtocol={this.revertProtocol}
        displayOptions={this.model.get('displayOptions')}
        spellCheck={this.model.get('displayOptions').getOption(vo.ELN_SPELL_CHECK.name).get('visible')}
        printLayout={printLayoutOption.get('visible')}
        showPrintMargins={printLayoutOption.isSettingChecked(vo.ELN_SHOW_PRINT_MARGINS.name)}
        // Deferred so we can wait until tab is added to the DOM before scrolling.
        // TODO(eln) rewrite once entry protocols aren't loaded async
        onLoad={this.onLoadProtocol}
      />
    );

    renderToDOM(component, this.el);
    return this;
  }
}
/* eslint-enable @typescript-eslint/unbound-method */
EntryProtocolTabView.initClass();

export const OptionsView = null;
export {EntryProtocolTabView as TabView};
